// View-only building blocks for the saved quote / Link page (QuotationViewDoc). Styling only —
// the wizard keeps its own components in ../QuotationDisplay.
import React from 'react';

export const C = {
  card: 'bg-white border border-[#E5E7EB] rounded-[8px] p-4 sm:p-5 min-w-0',
  body: 'text-[15px] text-[#374151]',
  long: 'text-sm text-[#374151]',  // inclusions, exclusions, terms
  label: 'text-sm text-[#6B7280]',
  th: 'px-3 py-2.5 text-sm font-semibold text-[#6B7280]',
  td: 'px-3 py-2.5 text-[15px] text-[#374151]',
  icon: 'w-[18px] h-[18px] shrink-0 text-[var(--navy)]',
  group: 'border border-[#E5E7EB] rounded-[8px] overflow-hidden bg-white',
  groupHead: 'bg-white border-b border-[#E5E7EB] px-3 sm:px-4 py-2.5 text-sm font-semibold text-[var(--navy)]',
};

export const SectionTitle = ({ icon: Icon, title, right, sub, testId }) => (
  <div className="mb-3">
    <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1">
      <h3 className="flex items-center gap-2 text-lg font-bold text-[var(--navy)] leading-7" data-testid={testId}>
        {Icon && <Icon className={C.icon} aria-hidden="true" />}
        {title}
      </h3>
      {right && <span className={C.label}>{right}</span>}
    </div>
    {sub && <p className={`${C.label} mt-0.5`} data-testid={testId && `${testId}-sub`}>{sub}</p>}
  </div>
);

export const Card = ({ id, title, icon, right, sub, children, testId }) => (
  <section className={C.card} data-testid={testId || `view-section-${id}`}>
    {title && <SectionTitle icon={icon} title={title} right={right} sub={sub} testId={`section-title-${id || testId}`} />}
    {children}
  </section>
);

// Grouped block inside a card (one hotel category, one day, one meal-plan table).
export const Group = ({ head, right, children, testId }) => (
  <div className={C.group} data-testid={testId}>
    {head && (
      <div className={`${C.groupHead} flex flex-wrap items-center justify-between gap-x-3 gap-y-1`}>
        <span className="min-w-0 break-words">{head}</span>
        {right && <span className={`${C.label} font-normal`}>{right}</span>}
      </div>
    )}
    {children}
  </div>
);

export const SimpleTable = ({ head, rows, rightFrom = 99, testid }) => (
  <div className="overflow-x-auto -mx-1 px-1">
    <table className="w-full min-w-max sm:min-w-0" data-testid={testid}>
      <thead>
        <tr className="border-b border-[#E5E7EB] text-left">
          {head.map((h, i) => <th key={`${h}${i}`} className={`${C.th} ${i >= rightFrom ? 'text-right' : ''}`}>{h}</th>)}
        </tr>
      </thead>
      <tbody>
        {rows.map((r, ri) => (
          <tr key={ri} className="border-b border-[#F3F4F6] last:border-b-0">
            {r.map((c, i) => <td key={i} className={`${C.td} ${i >= rightFrom ? 'text-right whitespace-nowrap' : ''}`}>{c}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const Bullets = ({ items }) => (
  <ul className={`list-disc pl-5 space-y-1 ${C.long}`}>{items.map((t, i) => <li key={i} className="break-words">{t}</li>)}</ul>
);
